import {AfterViewInit, ApplicationRef, Component, inject, signal} from '@angular/core';
import {AuthService} from './@core/services/auth.service';
import {NavigationEnd, Router} from '@angular/router';
import {filter, first} from 'rxjs/operators';
import {SwUpdate} from '@angular/service-worker';
import {concat, interval} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {AnalyticsService} from './@core/services/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.css'
})
export class App implements AfterViewInit{
  protected readonly title = signal('nbha-portal');
  isLoggedIn: boolean = false
  currentPath = '';

  constructor(private authService: AuthService, private router: Router, private swUpdate: SwUpdate,
              private appRef: ApplicationRef, private translate: TranslateService,
              private analyticsService: AnalyticsService) {
    this.authService.init();
    this.authService.isAuthenticated.subscribe((data) => {
      console.log("isAuthenticated", data)
      this.isLoggedIn = data
    })
    // Initialize currentPath immediately
    this.currentPath = this.router.url;

    // Initialize Google Analytics
    this.analyticsService.init();
  }

  private keenInit() {
    const w = window as any;

    // Global app/layout
    w.KTApp?.init?.();
    w.KTLayout?.init?.();

    // Create instances for data-kt-* components used in your header
    w.KTMenu?.init?.();
    w.KTDrawer?.init?.();
    w.KTScroll?.init?.();
    w.KTSticky?.init?.();
    w.KTToggle?.init?.();     // generic toggles (if present)
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentPath = event.url;
    });
  }

  ngAfterViewInit() {
    this.keenInit(); // first paint
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => setTimeout(() => this.keenInit()));
  }

  checkUpdates() {
    // Allow the app to stabilize first, before starting
    // polling for updates with `interval()`.
    const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable));
    const everySixHours$ = interval(10 * 1000);
    const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

    everySixHoursOnceAppIsStable$.subscribe(async () => {
      try {
        const updateFound = await this.swUpdate.checkForUpdate();
        if (updateFound) {
          if (confirm(this.translate.instant("applicationUpdateMessage"))) {
            document.location.reload();
          }
        } else {
        }
      } catch (err) {
      }
    });
  }
}
